module.exports = __webpack_public_path__ + "img/logo-only.bc9eaaf4.png";